import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';
const ContentProperty = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Content and Intellectual Property</h3>

      {/* Ownership Section */}
      <h4>Ownership</h4>
      <p>
        All course materials, including but not limited to training content,
        quizzes, assessments, and certificates, are the exclusive property of
        Yoda Safety Services. Users do not acquire any ownership rights to the
        content or materials provided on the portal.
      </p>

      {/* Usage Rights Section */}
      <h4>Usage Rights</h4>
      <p>
        Users are granted a limited, non-exclusive, non-transferable license to
        access and use the course materials for personal or professional
        development purposes. This license does not permit copying,
        distribution, modification, or resale of any content.
      </p>

      {/* Certificates Section */}
      <h4>Certificates</h4>
      <p>
        Certificates of completion are issued only to users who successfully
        complete the course requirements. These certificates are for personal
        use only and may not be altered, reproduced, or shared without prior
        written consent from Yoda Safety Services.
      </p>

      {/* Quizzes and Assessments Section */}
      <h4>Quizzes and Assessments</h4>
      <p>
        Quizzes and assessments provided as part of the course are intended
        solely for the enrolled users use. Sharing, reproducing, or distributing
        quiz questions or answers is strictly prohibited.
      </p>

      {/* Restrictions Section */}
      <h4>Prohibited Activities</h4>
      <p>Users are prohibited from:</p>
      <ul>
        <li>
          Copying, distributing, or modifying course materials without
          authorization.
        </li>
        <li>
          Sharing login credentials or granting access to unauthorized
          individuals.
        </li>
        <li>
          Using course content for commercial purposes without prior written
          consent.
        </li>
        <li>Altering or falsifying certificates of completion.</li>
      </ul>
    </PrivacyPolicyContainer>
  );
};

export default ContentProperty;
